import { FormControl, FormArray, FormBuilder, Validators } from '@angular/forms';
import { Product } from '@teem/models/product';
import { ProductAddon } from '@teem/models/product-addon';
import { ProductAddonForm } from '@teem/model-forms/product-addon-form';

export class ProductForm {

  uuid = new FormControl(null);
  store_id = new FormControl(null);
  category_id = new FormControl(null, [Validators.required]);
  product_number = new FormControl(null, [Validators.required]);
  name = new FormControl(null, [Validators.required]);
  name_ar = new FormControl(null);
  description = new FormControl(null);
  description_ar = new FormControl(null);
  preparation_time = new FormControl(null);
  quantity = new FormControl(null, [Validators.required, Validators.min(1)]);
  price = new FormControl(null, [Validators.required, Validators.min(0)]);
  discount_percent = new FormControl(null, [Validators.min(0.01), Validators.max(100)]);
  net_price = new FormControl(null, [Validators.min(0)]);
  product_image = new FormControl(null);
  active = new FormControl(1);
  weight = new FormControl(null, [Validators.min(0.01), Validators.max(100)]);
  micronutrients = new FormControl(1);
  calories = new FormControl(null, [Validators.min(0.01)]);
  proteins = new FormControl(null, [Validators.min(0.01)]);
  carbs = new FormControl(null, [Validators.min(0.01)]);
  add_ons = new FormArray([]);
  storefront_branches = new FormControl([]);

  constructor(product: Product) {
    if (product) {

      this.uuid.setValue(product.uuid);
      this.store_id.setValue(product.store_id);
      this.category_id.setValue(product.category_id);
      this.product_number.setValue(product.product_number);
      this.preparation_time.setValue(product.preparation_time);
      this.name.setValue(product.name);
      this.name_ar.setValue(product.name_ar);
      this.description.setValue(product.description);
      this.description_ar.setValue(product.description_ar);
      this.quantity.setValue(product.quantity);
      this.price.setValue(product.price);
      this.discount_percent.setValue(product.discount_percent);
      this.net_price.setValue(product.net_price);
      this.product_image.setValue(product.product_image);
      this.active.setValue(product.active);
      this.weight.setValue(product.weight);
      this.calories.setValue(product.calories);
      this.proteins.setValue(product.proteins);
      this.carbs.setValue(product.carbs);
      // this.storefront_branches.setValue(product.inactive_branch)

      if (product.add_ons && product.add_ons.length) {
        let fb = new FormBuilder();
        product.add_ons.forEach((addon) => {
          this.add_ons.push(
            fb.group(new ProductAddonForm(new ProductAddon(addon)))
          )
        })
      }
    }
  }

}